import { getQuizResultsTexts } from "./quiz-results-texts.js";

/**
 * Concern icons copied from Angular constants to preserve visual parity.
 */

/**
 * Escape user/content text before HTML injection.
 *
 * @param {any} value
 * @returns {string}
 */
function escapeHtml(value) {
  return String(value ?? "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#39;");
}

/**
 * Parse concerns from Octane answers payload.
 * Angular splits by ", " and treats result as an ordered list.
 *
 * @param {any} results
 * @returns {{ text: string, icon?: string }[]}
 */
function getConcerns(results) {
  const concernIcons = getQuizResultsTexts().concerns.icons;
  const concernsRaw = results?.answers?.Concerns;
  if (!concernsRaw || typeof concernsRaw !== "string") return [];

  const concerns = concernsRaw
    .split(", ")
    .map((item) => item.trim())
    .filter(Boolean);

  const withIcons = concerns.map((text) => ({
    text,
    icon: concernIcons[text],
  }));

  // Preserve Angular fallback:
  // if at least one icon is missing, render all items without icons.
  if (withIcons.some((item) => !item.icon)) {
    return concerns.map((text) => ({ text }));
  }

  return withIcons;
}

/**
 * Render concerns block .
 *
 * @param {Element | null} container
 * @param {any} results
 */
export function renderConcernsBlock(container, results) {
  if (!container) return;
  const iconAltSuffix = getQuizResultsTexts().concerns.iconAltSuffix;

  const concerns = getConcerns(results);
  if (!concerns.length) {
    container.innerHTML = "";
    return;
  }

  

  container.innerHTML = concerns
    .map((concern) => {
      const text = escapeHtml(concern.text);
      const icon = concern.icon
        ? `<img src="${concern.icon}" alt="${text}${escapeHtml(iconAltSuffix)}">`
        : "";

      return `
        <div class="quiz-results-intro-concerns-item" data-cy="quiz-results__concern">
          ${icon}
          <span class="is-uppercase">${text}</span>
        </div>
      `.trim();
    })
    .join("");
}
